import axios from "../../http";
import {
  BANNER_LIST_REQUEST,
  BANNER_LIST_SUCCESS,
  BANNER_LIST_FAIL,
} from "../Constants/BannerConstants";

export const listStoreBanners = () => async (dispatch) => {
  try {
    dispatch({ type: BANNER_LIST_REQUEST });

    const { data } = await axios.get("/api/banners/store", {
      params: {
        t: Date.now(),
      },
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
    });

    const normalizedBanners = Array.isArray(data)
      ? data
      : Array.isArray(data?.banners)
      ? data.banners
      : [];

    dispatch({
      type: BANNER_LIST_SUCCESS,
      payload: normalizedBanners,
    });
  } catch (error) {
    dispatch({
      type: BANNER_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};